export const SET_TECHNICIANSKILLS = 'SetTechnicianSkills';
export const SET_SKILLSETS_RESULT = 'SetSkillSetResult';
export const SET_RATELEVELS = 'SetRateLevels';
export const SET_TECHNICIAN_DETAILS = 'SetTechnicianDetails';
export const SET_SEARCHLISTRESULTS = 'SetSearchListResults';
export const CLEAR_SEARCHLISTRESULTS = 'ClearSearchListResults';
export const SET_SEARCHRESULTS = 'SetSearchResults';
export const SET_SELECTEDTECHNICIANS = 'SetSelectedTechnicians';
export const CLEAR_SELECTEDTECHNICIANS = 'ClearSelectedTechnicians';
export const UPDATE_SELECTEDTECHNICIANS = 'UpdateSelectedTechnicians';
export const SORT_POSITIONS = 'SortPositions';
export const ADD_SKILL_TO_EMPLOYEE = 'AddSkillToEmployee';
export const REMOVE_SKILL_FROM_EMPLOYEE = 'RemoveSkillFromEmployee';
export const CLEAR_DATA_FROM_EMPLOYEE = 'ClearDataFromEmployee';
export const ADD_RATE_TO_EMPLOYEE = 'AddRateToEmployee';
export const ADD_INFO_TECHNICIAN_RATE = 'AddInfoTechnicianRate';
export const UPDATE_TECHNICIANSKILLS_SKILLLEVELS = 'UpdateTechnicianSkillsSkillLevels';
export const SET_BULKTRANSACTIONPROCESSING = 'SetBulkTransactionProcessing';
export const UPDATE_TECHNICIANSKILLS_SKILLLEVELS_BULK = 'UpdateTechnicianSkillsSkillLevelsBulk';
export const SET_UNSAVED_BULK_ITEMS = 'UpdateUnsavedBulkItems';
export const SET_SAVED_BULK_ITEMS = 'UpdateSavedBulkItems';
export const SET_SKILLSETS_BULK_ITEMS = 'UpdateSkillSetsBulkItems';
export const CLEAR_UNSAVED_BULK_ITEMS = 'ClearUnsavedBulkItems';
export const CLEAR_SAVED_BULK_ITEMS = 'ClearSavedBulkItems';
export const CLEAR_SKILLSETS_BULK_ITEMS = 'ClearSkillSetsBulkItems';
export const SET_ERROR_MESSAGE_BULK_ITEMS = 'SetErrorMessageBulkItems';
export const CLEAR_ERROR_MESSAGE_BULK_ITEMS = 'ClearErrorMessageBulkItems';
export const CLEAR_SAVEDTECHNICIANS_BULK_ITEMS = 'ClearSavedTechniciansBulkItems';
export const ADD_DEFAULT_HOURLY_RATE_TO_EMPLOYEE = 'AddDefaultHourlyRateToEmployee';
